import { computed } from 'vue'

interface AuthHeaderProps {
  title: string
  subtitle: string
  logoSrc?: string
  logoAlt?: string
}

export function useAuthHeader(props: AuthHeaderProps) {
  const logoSource = computed(() => props.logoSrc || '/src/assets/OGBU-logo.png')
  const logoAltText = computed(() => props.logoAlt || 'OGBU Logo')

  return {
    logoSource,
    logoAltText,
  }
}
